import React from 'react'
import { Typography, Tooltip } from '@material-ui/core'

const SampleNameDisplay = React.memo(({ row }) => {
  const sampleName = row?.sample

  return sampleName ? (
    <Tooltip title={sampleName.length > 20 ? sampleName : ''}>
      <Typography>{sampleName.length > 20 ? `${sampleName.slice(0, 20)}...` : sampleName}</Typography>
    </Tooltip>
  ) : null
})

SampleNameDisplay.displayName = 'SampleNameDisplay'

export default SampleNameDisplay
